import { set } from 'lodash';
import { unwrap as buildResponseTransformation } from '../common';
var buildRequestTransformation = function (_a) {
    var requestMessageIdentifierPath = _a.requestMessageIdentifierPath;
    return set({}, requestMessageIdentifierPath, '$[0]');
};
export { buildRequestTransformation, buildResponseTransformation };
//# sourceMappingURL=get.js.map